import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import AuthContext from  "../context/AuthContext";

export default function PrivateWrapper({ children }) {

    const { user } = useContext(AuthContext);
    const authUser = localStorage.getItem('authTokens')

    // console.log('pathname: ', children._owner.dependencies.firstContext.memoizedValue.location.pathname)

    if (typeof user === "undefined") {
        return <div style={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <ProgressSpinner />
        </div>;
    }
    // else if (user?.user_id) {
    //     return children;
    // }

    return authUser ? children : <Navigate to='/login' />

}
